export const ADD_IMAGE = 'Tilføj billede';
export const PROVIDE_AN_IMAGE_LINK = 'eller skriv linket til et billede...';
export const DELETE_THE_IMAGE = 'Slet billedet';